export default __webpack_public_path__ + "static/media/Maidana.26b68d55.jpg";